import createCache from "@emotion/cache";
import { CacheProvider } from '@emotion/react';
import { Cancel, Check, CheckCircle, Download, Flaky, Help, KeyboardReturn } from '@mui/icons-material';
import { Button, ButtonGroup, FormControl, IconButton, InputLabel, MenuItem, Modal, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useMemo, useState } from 'react';
import { useMediaQuery } from "react-responsive";
import { toast } from 'react-toastify';
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import getReq from '../interface/getRequestinterface';
import postReq from '../interface/postRequestinterface';
import { getRequest, postRequest } from '../request';
import Loading from './loading';


const NimaFormList = [
  {
    id: 0,
    title: 'فرم درخواست صدور حواله ارزی',
  },
  {
    id: 1,
    title: 'پروفرما مشتری',
  },
  {
    id: 2,
    title: 'فرم ثبت سفارش',
  },
  {
    id: 3,
    title: 'فرم تعهد نامه',
  },
  {
    id: 4,
    title: 'روزنامه رسمی',
  },
  {
    id: 5,
    title: 'نامه معرفی نماینده',
  },
  {
    id: 6,
    title: 'نمونه امضاء',
  },
  {
    id: 7,
    title: 'فرم درخواست پرداخت کش',
  },

];
const NimaFormListReal = [
  {
    id: 0,
    title: 'فرم درخواست صدور حواله ارزی',
  },
  {
    id: 1,
    title: 'پروفرما مشتری',
  },
  {
    id: 2,
    title: 'فرم ثبت سفارش',
  },
  {
    id: 3,
    title: 'فرم تعهد نامه',
  },
  {
    id: 4,
    title: 'روزنامه رسمی',
  },
  {
    id: 5,
    title: 'نامه معرفی نماینده',
  },
  {
    id: 6,
    title: 'نمونه امضاء',
  },
  {
    id: 7,
    title: 'فرم درخواست پرداخت کش',
  },
  {
    id: 14,
    title: 'فرم اطلاعات اشخاص حقیقی',
  },
];
const SanaFormList = [
  {
    id: 12,
    title: 'فرم احراز هویت صرافی',
  },
  {
    id: 7,
    title: 'فرم درخواست پرداخت کش',
  },
  {
    id: 0,
    title: 'فرم درخواست پرداخت حواله ارزی',
  },
  {
    id: 11,
    title: 'نامه مختومه',
  },
  {
    id: 13,
    title: 'مجوز صرافی',
  },
  {
    id: 5,
    title: 'نامه معرفی نماینده',
  },
  {
    id: 9,
    title: 'شناسنامه',
  },
  {
    id: 10,
    title: 'کارت ملی',
  }
]
const tblHeader = [
  'فرم',
  'وضعیت',
  'دانلود فرم',
  'توضیحات مشتری',
  'نظر کارشناس',
  'تغییر وضعیت'
];
const style = {
  formTitle: {
    fontWeight: 'bold !important'
  },
  formDescription: {
    color: '#9b9b9b'
  },
  formContainer: {
    padding: '1rem !important',
    border: '3px solid #748DA6',
    borderRadius: '10px',
    backgroundColor: '#f1f7ff59',
    height: 'fit-content'
  },
  gridBox: {
    display: 'grid',
    gridTemplateColumns: '40% 40%',
    columnGap: '5%',
    rowGap: '3%',
    justifyContent: 'space-around',
    marginTop: '2rem'
  },
  mobileGridBox: {
    display: 'grid',
    gridTemplateColumns: '90%',
    // columnGap:'5%',
    rowGap: '3%',
    justifyContent: 'center',
    marginTop: '2rem'
  },
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: 4,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '3px',
    width: '30rem'
  },
  modalMobileStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: 4,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '3px',
    width: '15rem'
  },
  txtField: {
    width: '100%',
  },
  headerContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between'
  },
  stateHandler: {
    display: 'flex',
    justifyContent: 'center'
  },
  stateType: { fontWeight: 'bold' },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '65rem',
  }
}

interface FormData {
  clientComment: string;
  expertComment: string;
  fileName: string;
  fileType: string;
  requestCode: number;
  uploudTime: string;
  formId: number;
  state: number;
  type: number;
}
interface ChangeState {
  formId: number;
  formstate: number;
}
function ExpertCheckForms() {
  const [receivedList, setReceivedList] = useState<Array<FormData>>([]);
  const [selectedForm, setSelectedForm] = useState<number>(-1);
  const [description, setDescription] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false);
  const [openExpertDescModal, setOpenExpertDescModal] = useState<boolean>(false);
  const [openClientDescModal, setOpenClientDescModal] = useState<boolean>(false);
  const [expertComment, setExpertComment] = useState<string>('');
  const [clientComment, setClientComment] = useState<string>('');
  const [userType, setUserType] = useState({ ctype: '', newOrOld: '' });
  const [changeState, setChangeState] = useState<ChangeState>({
    formId: -1,
    formstate: 0,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);


  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)"
  });

  const handleDownloadFile = async (index) => {
    // Define the API endpoint and headers

    const token = localStorage.getItem('token');
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/Form/GetFile/${receivedList.find(x => x.type === index)?.formId}`; // Replace with your API endpoint
    const headers = {
      'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
      'Content-Type': 'application/json', // Set the content type if needed
    };

    // Make a GET request with the Authorization header
    fetch(apiUrl, {
      method: 'GET',
      headers: headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response;
      })
      .then((response) => response.blob())
      .then((blob) => {
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // For IE and Edge browsers
          window.navigator.msSaveBlob(blob, 'image.png');
        } else {
          // Create a URL for the blob data
          const url = window.URL.createObjectURL(blob);

          // Create an anchor element for downloading
          const a = document.createElement('a');
          a.href = url;
          a.download = 'image.jpg'; // You can specify the desired filename here

          // Programmatically trigger a click event on the anchor element
          a.click();

          // Clean up by revoking the URL object
          window.URL.revokeObjectURL(url);
        }
      })
      .catch((error) => {
        console.error('Error downloading image:', error);
      });
  }

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenExpertDescModal = () => setOpenExpertDescModal(true);
  const handleCloseExpertDescModal = () => setOpenExpertDescModal(false);
  const handleOpenClientDescModal = () => setOpenClientDescModal(true);
  const handleCloseClientDescModal = () => setOpenClientDescModal(false);
  const cacheRtl = useMemo(() => {
    return createCache({
      key: "muirtl",
      stylisPlugins: [prefixer, rtlPlugin]
    });
  }, []);
  const requestType = JSON.parse(localStorage.getItem('requestType')!);
  const requestDetails = JSON.parse(localStorage.getItem('requestDetails')!);
  const getForms = async () => {
    const { data, error }: getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/Form/GetForms/${requestDetails.requestNumber}`) as getReq;
    if (error) {
      toast.error(error);
    } else {
      setReceivedList(data);
      setTimeout(() => {
        setIsLoading(true);
      }, 1500);
    }
  }
  useEffect(() => {
    getForms();
    handleGetRequestType();
  }, [])

  const handleChange = (event, index) => {
    setChangeState({
      formstate: event.target.value,
      formId: index,
    });
    setReceivedList((prevState) => {
      return prevState.map((item) => {
        if (item.formId === index) {
          let tempItem: FormData = item;
          tempItem.state = event.target.value
          return tempItem
        }
        return item;
      })
    })
  };
  const handleChangeForms = async () => {
    setSelectedForm(-1);
    setOpen(false);
    let temp: any = changeState;
    temp.comment = description;
    const response: postReq = await postRequest(`${process.env.REACT_APP_BASE_URL}/Form/SetState`, temp) as postReq;
    if (response.message === 'ok') {
      toast.success('درخواست با موفقیت اعمال شد');
      window.location.reload();
    } else {
      toast.error(response.error);
    }
  }
  const handleShowExpertComment = (index) => {
    handleOpenExpertDescModal();
    setExpertComment(receivedList.find(x => x.type === index)?.expertComment!);
  }
  const handleShowClientComment = (index) => {
    handleOpenClientDescModal();
    setClientComment(receivedList.find(x => x.type === index)?.clientComment!);
  }
  const handleGetRequestType = async () => {
    const response: getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/Form/UserInfoAdmin/${requestDetails.requestNumber}`) as getReq;
    if (!response.error) {
      setUserType({ ctype: response.data.ctype, newOrOld: response.data.newOrOld });
    }
  }
  return (
    <CacheProvider value={cacheRtl}>
      {isLoading ?
        <div className='background'>
          <div className="container">
            <div style={isDesktop ?
              { width: "100%", justifyContent: 'center', display: 'flex', position: 'relative', top: '-3rem' } :
              { width: "100%", justifyContent: 'center', display: 'flex', position: 'relative', top: '0rem' }
            }>
              <div className="currencyRatesHeader">
                <div className="firstElementTag">
                  <span style={{ color: "#efefef" }}>نام مشتری </span>
                  <span className="secondElementTag"
                  ><b>{requestDetails.userName}</b></span>
                </div>
                <div className="firstElementTag">
                  <span style={{ color: "#efefef" }}>شماره درخواست</span>
                  <span className="secondElementTag"><b>{requestDetails.requestNumber}</b></span>
                </div>
              </div>
            </div>
            {/* <Box sx={isDesktop?{display:'flex',justifyContent:'center',position:'relative',top:'-3rem'}:
              {display:'flex',position:'relative',top:'-1rem'}
          }>
          <Box sx={isDesktop?style.title:{display:'flex',flexDirection:'column',position:'relative',top:'1rem'}}>
            <Typography variant="h6" color="initial" sx={{fontWeight:'bold'}}>{requestDetails.userName}</Typography>
            <Typography variant="h6" color="initial">شماره درخواست: <span style={{fontWeight:'bold'}}>{requestDetails.requestNumber}</span></Typography>
          </Box>
        </Box> */}
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <TableContainer component={Paper} sx={{ display: 'flex', justifyContent: 'center', width: 'fit-content' }}>
                <Table aria-label="simple table" sx={{ display: 'block' }}>
                  <TableHead>
                    <TableRow>
                      {
                        tblHeader.map(
                          (x, idx) =>
                            <TableCell className='ratesTh' key={idx} align="center">{x}</TableCell>
                          // <th className='th' key={idx}>{x}</th>
                        )
                      }
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {requestType.sanaOrNima === 'Nima' ? (
                      userType.ctype === 'حقوقی' || userType.ctype === 'حقوقي' ?
                        NimaFormList?.map((form, index) =>
                          <TableRow className='ratesTr'
                            key={index}
                            sx={{ '&:last-child , &:last-child': { border: 0 } }}
                          >
                            <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                              {form.title}
                            </TableCell>
                            {receivedList.find(x => x.type === form.id) ? (
                              selectedForm !== index ?
                                receivedList.find(x => x.type === form.id)?.state === 0 ?
                                  <TableCell align="center">
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                      {isDesktop ? <span>تعیین وضعیت نشده</span> : null}<Help />
                                    </div>
                                  </TableCell> :
                                  receivedList.find(x => x.type === form.id)?.state === 1 ?
                                    <TableCell align="center">
                                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        {isDesktop ? <span>تایید شده</span> : null} <CheckCircle sx={{ color: 'green' }} />
                                      </div>
                                    </TableCell> :
                                    <TableCell align="center" >
                                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        {isDesktop ? <span>عدم تایید</span> : null}<Cancel sx={{ color: '#bf0639' }} />
                                      </div>
                                    </TableCell>
                                :
                                <TableCell align="center">
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">وضعیت</InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={receivedList.find(x => x.type === form.id)?.state === 0 ? 0 : receivedList.find(x => x.type === form.id)?.state === 1 ? 1 : 2}
                                      label="Age"
                                      size='small'
                                      onChange={(e) => handleChange(e, receivedList.find(x => x.type === form.id)?.formId)}
                                    >
                                      <MenuItem value={0}>تعیین وضعیت نشده</MenuItem>
                                      <MenuItem value={1}>تایید</MenuItem>
                                      <MenuItem value={2}>عدم تایید</MenuItem>
                                    </Select>
                                  </FormControl>
                                </TableCell>
                            ) :
                              <TableCell className='ratesTd' align="center">
                                فایل بارگزاری نشده
                              </TableCell>
                            }
                            {
                              receivedList.find(x => x.type === index) ? (
                                <TableCell align="center">
                                  <IconButton
                                    color='primary'
                                    onClick={() => handleDownloadFile(form.id)}
                                  >
                                    <Download />
                                  </IconButton>
                                </TableCell>
                              ) :
                                <TableCell className='ratesTd' align="center">
                                  -
                                </TableCell>
                            }
                            {receivedList.find(x => x.type === form.id) ? (
                              <TableCell className='ratesTd' align="center" sx={{ cursor: 'pointer' }} onClick={() => handleShowClientComment(form.id)}>
                                {
                                  receivedList.find(x => x.type === form.id)?.clientComment ?
                                    receivedList.find(x => x.type === form.id)?.clientComment?.length! > 40 ?
                                      receivedList.find(x => x.type === form.id)?.clientComment.slice(0, 40) + '...' :
                                      receivedList.find(x => x.type === form.id)?.clientComment : 'توضیحی ثبت نشده'
                                }
                              </TableCell>
                            ) :
                              <TableCell className='ratesTd' align="center">
                                -
                              </TableCell>
                            }
                            {receivedList.find(x => x.type === form.id) ? (
                              <TableCell className='ratesTd' align="center"
                                sx={{
                                  cursor: 'pointer',
                                }}
                                onClick={() => handleShowExpertComment(form.id)}>
                                {
                                  receivedList.find(x => x.type === form.id)?.expertComment ?
                                    receivedList.find(x => x.type === form.id)?.expertComment?.length! > 40 ?
                                      receivedList.find(x => x.type === form.id)?.expertComment.slice(0, 40) + '...' :
                                      receivedList.find(x => x.type === form.id)?.expertComment : 'نظری ثبت نشده'
                                }
                              </TableCell>

                            ) :
                              <TableCell className='ratesTd' align="center">
                                -
                              </TableCell>
                            }
                            {
                              receivedList.find(x => x.type === form.id) ? (
                                <TableCell align="center">
                                  {selectedForm === form.id ?
                                    <ButtonGroup variant="contained" aria-label="">
                                      <Button color='primary' onClick={handleOpen}>اعمال <Check /></Button>
                                      <Button color='secondary' onClick={() => setSelectedForm(-1)}>بازگشت<KeyboardReturn /></Button>
                                    </ButtonGroup> :
                                    <IconButton onClick={() => setSelectedForm(form.id)}>
                                      <Flaky sx={{ color: '#1e1e1e' }} />
                                    </IconButton>
                                  }
                                </TableCell>
                              ) : <TableCell className='ratesTd' align="center">
                                -
                              </TableCell>
                            }
                          </TableRow>
                        ) :
                        NimaFormListReal?.map((form, index) =>
                          <TableRow className='ratesTr'
                            key={index}
                            sx={{ '&:last-child , &:last-child': { border: 0 } }}
                          >
                            <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                              {form.title}
                            </TableCell>
                            {receivedList.find(x => x.type === form.id) ? (
                              selectedForm !== index ?
                                receivedList.find(x => x.type === form.id)?.state === 0 ?
                                  <TableCell align="center">
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                      {isDesktop ? <span>تعیین وضعیت نشده</span> : null}<Help />
                                    </div>
                                  </TableCell> :
                                  receivedList.find(x => x.type === form.id)?.state === 1 ?
                                    <TableCell align="center">
                                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        {isDesktop ? <span>تایید شده</span> : null} <CheckCircle sx={{ color: 'green' }} />
                                      </div>
                                    </TableCell> :
                                    <TableCell align="center" >
                                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        {isDesktop ? <span>عدم تایید</span> : null}<Cancel sx={{ color: '#bf0639' }} />
                                      </div>
                                    </TableCell>
                                :
                                <TableCell align="center">
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">وضعیت</InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={receivedList.find(x => x.type === form.id)?.state === 0 ? 0 : receivedList.find(x => x.type === form.id)?.state === 1 ? 1 : 2}
                                      label="Age"
                                      size='small'
                                      onChange={(e) => handleChange(e, receivedList.find(x => x.type === form.id)?.formId)}
                                    >
                                      <MenuItem value={0}>تعیین وضعیت نشده</MenuItem>
                                      <MenuItem value={1}>تایید</MenuItem>
                                      <MenuItem value={2}>عدم تایید</MenuItem>
                                    </Select>
                                  </FormControl>
                                </TableCell>
                            ) :
                              <TableCell className='ratesTd' align="center">
                                فایل بارگزاری نشده
                              </TableCell>
                            }
                            {
                              receivedList.find(x => x.type === index) ? (
                                <TableCell align="center">
                                  <IconButton
                                    color='primary'
                                    onClick={() => handleDownloadFile(form.id)}
                                  >
                                    <Download />
                                  </IconButton>
                                </TableCell>
                              ) :
                                <TableCell className='ratesTd' align="center">
                                  -
                                </TableCell>
                            }
                            {receivedList.find(x => x.type === form.id) ? (
                              <TableCell className='ratesTd' align="center" sx={{ cursor: 'pointer' }} onClick={() => handleShowClientComment(form.id)}>
                                {
                                  receivedList.find(x => x.type === form.id)?.clientComment ?
                                    receivedList.find(x => x.type === form.id)?.clientComment?.length! > 40 ?
                                      receivedList.find(x => x.type === form.id)?.clientComment.slice(0, 40) + '...' :
                                      receivedList.find(x => x.type === form.id)?.clientComment : 'توضیحی ثبت نشده'
                                }
                              </TableCell>
                            ) :
                              <TableCell className='ratesTd' align="center">
                                -
                              </TableCell>
                            }
                            {receivedList.find(x => x.type === form.id) ? (
                              <TableCell className='ratesTd' align="center"
                                sx={{
                                  cursor: 'pointer',
                                }}
                                onClick={() => handleShowExpertComment(form.id)}>
                                {
                                  receivedList.find(x => x.type === form.id)?.expertComment ?
                                    receivedList.find(x => x.type === form.id)?.expertComment?.length! > 40 ?
                                      receivedList.find(x => x.type === form.id)?.expertComment.slice(0, 40) + '...' :
                                      receivedList.find(x => x.type === form.id)?.expertComment : 'نظری ثبت نشده'
                                }
                              </TableCell>

                            ) :
                              <TableCell className='ratesTd' align="center">
                                -
                              </TableCell>
                            }
                            {
                              receivedList.find(x => x.type === form.id) ? (
                                <TableCell align="center">
                                  {selectedForm === form.id ?
                                    <ButtonGroup variant="contained" aria-label="">
                                      <Button color='primary' onClick={handleOpen}>اعمال <Check /></Button>
                                      <Button color='secondary' onClick={() => setSelectedForm(-1)}>بازگشت<KeyboardReturn /></Button>
                                    </ButtonGroup> :
                                    <IconButton onClick={() => setSelectedForm(form.id)}>
                                      <Flaky sx={{ color: '#1e1e1e' }} />
                                    </IconButton>
                                  }
                                </TableCell>
                              ) : <TableCell className='ratesTd' align="center">
                                -
                              </TableCell>
                            }
                          </TableRow>
                        )
                    ) :
                      SanaFormList?.map((form, index) =>
                        <TableRow className='ratesTr'
                          key={index}
                          sx={{ '&:last-child , &:last-child': { border: 0 } }}
                        >
                          <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                            {form.title}
                          </TableCell>
                          {receivedList.find(x => x.type === form.id) ? (
                            selectedForm !== form.id ?
                              receivedList.find(x => x.type === form.id)?.state === 0 ?
                                <TableCell align="center">
                                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    {isDesktop ? <span>تعیین وضعیت نشده</span> : null}<Help />
                                  </div>
                                </TableCell> :
                                receivedList.find(x => x.type === form.id)?.state === 1 ?
                                  <TableCell align="center">
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                      {isDesktop ? <span>تایید شده</span> : null} <CheckCircle sx={{ color: 'green' }} />
                                    </div>
                                  </TableCell> :
                                  <TableCell align="center" >
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                      {isDesktop ? <span>عدم تایید</span> : null}<Cancel sx={{ color: '#bf0639' }} />
                                    </div>
                                  </TableCell>
                              :
                              <TableCell align="center">
                                <FormControl fullWidth>
                                  <InputLabel id="demo-simple-select-label">وضعیت</InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={receivedList.find(x => x.type === form.id)?.state === 0 ? 0 : receivedList.find(x => x.type === form.id)?.state === 1 ? 1 : 2}
                                    label="Age"
                                    size='small'
                                    onChange={(e) => handleChange(e, receivedList.find(x => x.type === form.id)?.formId)}
                                  >
                                    <MenuItem value={0}>تعیین وضعیت نشده</MenuItem>
                                    <MenuItem value={1}>تایید</MenuItem>
                                    <MenuItem value={2}>عدم تایید</MenuItem>
                                  </Select>
                                </FormControl>
                              </TableCell>
                          ) :
                            <TableCell className='ratesTd' align="center">
                              فایل بارگزاری نشده
                            </TableCell>
                          }
                          {
                            receivedList.find(x => x.type === form.id) ? (
                              <TableCell align="center">
                                <IconButton
                                  color='primary'
                                  onClick={() => handleDownloadFile(form.id)}
                                >
                                  <Download />
                                </IconButton>
                              </TableCell>
                            ) :
                              <TableCell className='ratesTd' align="center">
                                -
                              </TableCell>
                          }
                          {receivedList.find(x => x.type === form.id) ? (
                            <TableCell className='ratesTd' align="center" sx={{ cursor: 'pointer' }} onClick={() => handleShowClientComment(form.id)}>
                              {
                                receivedList.find(x => x.type === form.id)?.clientComment ?
                                  receivedList.find(x => x.type === form.id)?.clientComment?.length! > 40 ?
                                    receivedList.find(x => x.type === form.id)?.clientComment.slice(0, 40) + '...' :
                                    receivedList.find(x => x.type === form.id)?.clientComment : 'توضیحی ثبت نشده'
                              }
                            </TableCell>
                          ) :
                            <TableCell className='ratesTd' align="center">
                              -
                            </TableCell>
                          }
                          {receivedList.find(x => x.type === form.id) ? (
                            <TableCell className='ratesTd' align="center"
                              sx={{
                                cursor: 'pointer',
                              }}
                              onClick={() => handleShowExpertComment(form.id)}>
                              {
                                receivedList.find(x => x.type === form.id)?.expertComment ?
                                  receivedList.find(x => x.type === form.id)?.expertComment?.length! > 40 ?
                                    receivedList.find(x => x.type === form.id)?.expertComment.slice(0, 40) + '...' :
                                    receivedList.find(x => x.type === form.id)?.expertComment : 'نظری ثبت نشده'
                              }
                            </TableCell>

                          ) :
                            <TableCell className='ratesTd' align="center">
                              -
                            </TableCell>
                          }
                          {
                            receivedList.find(x => x.type === form.id) ? (
                              <TableCell align="center">
                                {selectedForm === form.id ?
                                  <ButtonGroup variant="contained" aria-label="">
                                    <Button color='primary' onClick={handleOpen}>اعمال <Check /></Button>
                                    <Button color='secondary' onClick={() => setSelectedForm(-1)}>بازگشت<KeyboardReturn /></Button>
                                  </ButtonGroup> :
                                  <IconButton onClick={() => setSelectedForm(form.id)}>
                                    <Flaky sx={{ color: '#1e1e1e' }} />
                                  </IconButton>
                                }
                              </TableCell>
                            ) : <TableCell className='ratesTd' align="center">
                              -
                            </TableCell>
                          }
                        </TableRow>
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
        :
        <div style={{ width: '100vw', height: 'calc( 100vh - 64px)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Loading type="cylon" color="#000" />
        </div>
      }
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style.modalStyle}>
          <Typography variant="caption" sx={{ color: '#aaa' }}>
            * اگر توضیحی در ارتباط با فایل کاربر دارید در فیلد زیر وارد کرده و تایید نمایید
          </Typography>
          <TextField
            id="outlined-multiline-static"
            label="توضیحات"
            multiline
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            sx={{ marginBottom: '0.5rem' }}
          />
          <ButtonGroup variant="contained" sx={{ width: 'fit-content' }}>
            <Button variant="contained" color="primary" onClick={handleChangeForms}>
              تایید<Check />
            </Button>
            <Button variant="contained" color="secondary" onClick={handleClose}>
              بازگشت<KeyboardReturn />
            </Button>
          </ButtonGroup>
        </Box>
      </Modal>
      <Modal
        open={openExpertDescModal}
        onClose={handleCloseExpertDescModal}
      >
        <Box sx={isDesktop ? style.modalStyle : style.modalMobileStyle}>
          <Typography variant="h6" color="initial" sx={{ fontWeight: 'bold' }}>نظر کارشناس </Typography>
          <Typography variant='body1' color="initial" sx={{ border: '2px solid #bdbdbd', borderRadius: '5px', wordBreak: 'break-word', padding: '1rem' }}>{expertComment ? expertComment : 'نظری ثبت نشده'}</Typography>
        </Box>
      </Modal>
      <Modal
        open={openClientDescModal}
        onClose={handleCloseClientDescModal}
      >
        <Box sx={isDesktop ? style.modalStyle : style.modalMobileStyle}>
          <Typography variant="h6" color="initial" sx={{ fontWeight: 'bold' }}>توضیح مشتری </Typography>
          <Typography variant='body1' color="initial" sx={{ border: '2px solid #bdbdbd', borderRadius: '5px', wordBreak: 'break-word', padding: '1rem' }}>{clientComment ? clientComment : 'توضیحی ثبت نشده'}</Typography>
        </Box>
      </Modal>
    </CacheProvider>
  )
}

export default ExpertCheckForms
